import React from 'react'

import ThumbsUpIcon from '@Assets/SVG/ThumbsUp'
import { Button } from '@Components/Button'
import { Title } from '@Components/CMS/Title'
import { SVGIcon } from '@Components/Icons/SVGIcon'
import { useTranslation } from '@Globals/Translations'

import styles from './LeadMagnetSuccess.module.scss'

interface SuccessProps {
  onClose: () => void
  successMsg: string
}

export const Success = ({ onClose, successMsg }: SuccessProps) => {
  const { t } = useTranslation()

  return (
    <div className={styles.leadMagnetSuccess}>
      <span className={styles.thumbsIcon}>
        <SVGIcon icon={ThumbsUpIcon} size="80px" />
      </span>

      <Title title={t('common:THANK_YOU')} type="h1" />
      <p className={styles.successMsg}>{successMsg}</p>
      <Button color="dark" onClick={() => onClose()} variant="outlined">
        {t('common:CLOSE')}
      </Button>
    </div>
  )
}
